<template>
  <div>
    <el-row class="header" type="flex" justify="center">
      <el-col :span="8" class="bor row" style="min-width:400px">
        <a href="javascript:;" @click="goHome" style="text-align: center;">
          <img class="logo" src="/static/img/logo2022.png" />
        </a>
      </el-col>
      <el-col :span="10" :class="['bor row visb',showSearch ?'viss':'']">
        <!-- <el-input placeholder="输入任意内容查询主题、方向、专家、机构" v-model="value" @keyup.enter.native="search">
          <i slot="suffix"  v-if="value" class="el-icon-close" @click="clear()"></i>
          <i slot="suffix" class="el-icon-search" @click="search()"></i>
        </el-input>-->
      </el-col>
      <el-col :span="6" class="row">
        <div @click="login()" v-if="!user" class="btn">
          <span @click="login()">登录</span>
          <span>/</span>
          <span @click="reg()">注册</span>
        </div>
        <div v-else class="btn">
          <span @click="center()">{{ user.Name}} 个人中心</span>
          <span @click="logout()">/退出</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { login, reg, exit } from '@/utils/index'
export default {
  name: 'Header',
  data () {
    return {
      value: localStorage.getItem('val') ? localStorage.getItem('val') : '',
      loading: '',
      user: localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : '',
      showSearch: false,
      route: false
    }
  },

  mounted () {
    // debugger
    this.$nextTick(function () {
      // localStorage.removeItem('val')

      setTimeout(() => {
        console.log('mouted')
        if (!this.route) {
          if (
            this.$route.path == '/RetrieveField' ||
            this.$route.path == '/RetrieveInst' ||
            this.$route.path == '/RetrieveName'
          ) {
            this.showSearch = false
          } else {
            this.showSearch = true
          }
        }
      }, 1000)
    })
  },
  methods: {
    goFormalState () {
      window.location.href = 'http://expert.ckcest.cn/state'
    },
    goFormalHelp () {
      window.location.href = 'http://expert.ckcest.cn/help'
    },
    search () {
      if (!this.value) {
        this.$message.closeAll()
        this.$message({
          message: '请输入搜索内容',
          type: 'warning'
        })
        return
      }
      if (this.value.length === 1) {
        this.$message('请输入更多的关键词')
        return
      }
      localStorage.setItem('highVal', this.value)
      this.$store.commit('setSearchTxt', this.value)
      this.$router.push({ name: 'Loading', params: { data: this.value } })
    },
    reg () {
      reg()
    },
    clear () {
      this.value = ''
    },
    goHome () {
      if (this.path === 'Home') {
        return
      }
      this.$router.push({ name: 'Home' })
    },
    center () {
      if (this.path === '/center') {
        return
      }
      this.$router.push({ name: 'center' })
    },
    login () {
      login()
    },
    logout () {
      exit()
      this.$message('退出成功')
    }
  },
  computed: {
    searchTxt () {
      console.log(this.$store.state.searchTxt)
      return this.$store.state.searchTxt
    }
  },
  watch: {
    searchTxt (val) {
      if (val) {
        this.value = val
      }
    },
    $route (to, from) {
      debugger
      console.log('routeWatch')
      this.route = true
      localStorage.removeItem('highSearch')
      if (
        to.path == '/RetrieveField' ||
        to.path == '/RetrieveInst' ||
        to.path == '/RetrieveName'
      ) {
        this.showSearch = false
      } else {
        this.showSearch = true
      }
      if (to.path === '/Loading') {
        if (localStorage.getItem('val')) {
          this.value = localStorage.getItem('val')
          this.$nextTick(function () {
            localStorage.removeItem('val')
          })
        }
      }
      this.path = to.path
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  .logo{
    height: 50px;
    width: auto !important;
  }
}
input::-ms-clear {
  display: none;
}
.bor {
  border-right: 1px solid #000000;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.btn {
  cursor: pointer;
  font-family: "黑体";
  font-size: 1.5em;
}
.visb {
  visibility: hidden;
}
.viss {
  visibility: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue